import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "address-remove" }
const _hoisted_2 = { class: "address-remove__caption" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "address-remove__line" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "address-remove__error"
}
const _hoisted_5 = { class: "address-remove__actions" }
const _hoisted_6 = ["disabled"]

import { ref } from 'vue';

import useUser from '@/composables/useUser';
import useContext from '@/composables/useContext';
import useAddress from '@/composables/useAddress';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useEventListener from '@/composables/useEventListener';

import DrawerLayer from '@distancify-storefront/ui-drawer-layer';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressRemove',
  setup(__props) {

const { route, mitt, navigateToLoginPage } = useContext();
const { user } = useUser();
const { requestPending, deleteShippingAddress } = useAddress();
const { websiteText } = useWebsiteTexts();
const { useEmitterEventListener } = useEventListener();

const error = ref('');

const isOpen = ref(false);
const address = ref(null);

async function open(addressData: any) {
  if (user.value?.isAuthenticated) {
      address.value = addressData;
      isOpen.value = true;
    } else if (!route.value?.query?.action) {
      const query = route.value?.query || {};
      navigateToLoginPage(query);
    }
}

async function removeDeliveryAddress() {
  try {
    error.value = '';
    await deleteShippingAddress({
      no: address.value?.no,
      code: address.value?.code,
      systemId: address.value?.systemId,
    });

    mitt.emit('Remove:DeliveryAddress:Success');
    close();
  } catch (err: any) {
    error.value = err;
  }
}

function close() {
  if(requestPending.value) return;
  isOpen.value = false;
  address.value = null;
}

useEmitterEventListener('Remove:DeliveryAddress:Open', open);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DrawerLayer), {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    showCloseIcon: true,
    containerClass: "address-remove__modal-container",
    modalClass: "address-remove__modal--center"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(websiteText)('global__delivery_address_remove_caption').value), 1),
        _hoisted_3,
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "primary-button",
            disabled: _unref(requestPending),
            onClick: removeDeliveryAddress
          }, _toDisplayString(_unref(websiteText)('global_delivery_address_remove').value), 9, _hoisted_6),
          _createElementVNode("button", {
            class: "quarternary-button",
            onClick: close
          }, _toDisplayString(_unref(websiteText)('global__cancel').value), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})